/**
 * boundsのモデルクラス
 */
class Bounds {
  /**
   * コンストラクタ
   *
   * @param {Object} bounds boundsデータ
   * @property {Array.<Number>} bounds.sw boundsの南西端(経度,緯度)
   * @property {Array.<Nnumber>} bounds.ne boundsの北東端(経度,緯度)
   */
  constructor(bounds) {
    this.w = bounds ? bounds.sw[0] : 0
    this.s = bounds ? bounds.sw[1] : 0
    this.e = bounds ? bounds.ne[0] : 0
    this.n = bounds ? bounds.ne[1] : 0
    this._correctEastWestReversal()
  }

  /**
   * 大きさが無い場合はtrue
   * @type {Boolean}
   */
  get isEmpty() {
    return this.w === 0 && this.s === 0 && this.e === 0 && this.n === 0
  }

  /**
   * 1点の場合はtrue
   * @type {Boolean}
   */
  get isPoint() {
    return this.w === this.e && this.s === this.n
  }

  /**
   * 東西逆転を補正する
   */
  _correctEastWestReversal() {
    if (this.e < this.w) {
      this.e += 360
    }
  }

  /**
   * 一致判定
   * @param {Bounds} bounds bounds
   * @returns {Boolean} 同じ範囲の場合はtrue
   */
  equals(bounds) {
    return (
      bounds.w === this.w &&
      bounds.s === this.s &&
      bounds.e === this.e &&
      bounds.n === this.n
    )
  }

  /**
   * 包含判定
   * @param {Bounds} bounds bounds
   * @returns {Boolean} 包含している場合はtrue
   */
  contains(bounds) {
    return (
      bounds.w >= this.w &&
      bounds.s >= this.s &&
      bounds.e <= this.e &&
      bounds.n <= this.n
    )
  }

  /**
   * 結合する
   * @param {Bounds} bounds bounds
   * @returns {Bounds} this
   */
  union(bounds) {
    if (bounds.isEmpty) return
    this.w = bounds.w < this.w ? bounds.w : this.w
    this.s = bounds.s < this.s ? bounds.s : this.s
    this.e = bounds.e > this.e ? bounds.e : this.e
    this.n = bounds.n > this.n ? bounds.n : this.n
    return this
  }

  /**
   * 文字列化
   * @returns {String} 文字列化されたbounds(w,s e,n)
   */
  toString() {
    return `${this.w},${this.s} ${this.e},${this.n}`
  }

  /**
   * オブジェクト化
   * @returns {Object} boundsオブジェクト
   */
  toObject() {
    return {
      sw: [this.w, this.s],
      ne: [this.e, this.n],
    }
  }

  /**
   * ポリゴンジオメトリ化
   * @returns {Object} ポリゴンジオメトリ
   */
  toPolygon() {
    return {
      type: 'Polygon',
      coordinates: [
        [
          [this.w, this.s],
          [this.e, this.s],
          [this.e, this.n],
          [this.w, this.n],
          [this.w, this.s],
        ],
      ],
    }
  }
}

export default Bounds
